import request from '../../utils/request';

export function getReportList(params) {
  return request({
    url: '/reports',
    method: 'get',
    params,
  });
}

export function getReportDetail(params) {
  return request({
    url: `/reports/${params.serial_number}`,
    method: 'get',
  });
}

export function replyComment(params) {
  return request({
    url: `/reports/comments`,
    method: 'post',
    data: params,
  });
}

export function addReport(params) {
  return request({
    url: '/reports',
    method: 'post',
    data: params,
  });
}

export function getUserReport(params) {
  return request({
    url: `/user-center/reports`,
    method: 'get',
    params,
  });
}

export function getTeamAuthor(params) {
  return request({
    url: `/getAuthors`,
    method: 'get',
    params,
  });
}

// 报告类型
export function getCategories() {
  return request({
    url: `/categories?with_children=1`,
    method: 'get',
  });
}

// 报告等级
export function getlevels() {
  return request({
    url: '/levels',
    method: 'get',
  });
}

export function getCompanyReportList(params) {
  return request({
    url: `company-center/reports`,
    method: 'get',
    params
  });
}

export function getReportComment({ report_id, page }) {
  return request({
    url: `reports/${report_id}/comments?page=${page}`,
    method: 'get',
  });
}
// 报告对话列表
export function getConversationList({ serial_number }) {
  return request(`reports/${serial_number}/dialogs`, {
    method: 'GET',
  });
}

// 提交对话
export function submitConversation({ serial_number, content, attachmentIds }) {
  return request(`reports/dialogs`, {
    method: 'POST',
    data: {
      report_serial_number: serial_number,
      content,
      attachment_ids: attachmentIds.length ? attachmentIds : undefined
    },
  });
}

// reward
export function RewardReport({ serial_number, whiteHatTxHash,platformTxHash }) {
  return request(`company-center/reports/reward`, {
    method: 'post',
    data: {
      serial_number,
      whitehat_txhash: whiteHatTxHash,
      platform_txhash: platformTxHash,
    },
  });
}
